import { AdditionalOrderColumn, OrdersTab } from 'enums';
import { useOrderQueryFilters } from 'hooks';

import { DisputeOrders } from '../DisputeOrders';

export const ProviderDisputeOrders: React.FC = () => {
  useOrderQueryFilters();
  return (
    <DisputeOrders
      tab={OrdersTab.ProviderDispute}
      additionalColumns={[AdditionalOrderColumn.P2PProvider]}
    />
  );
};
